
export const common = {
  // Navigation
  home: "Home",
  about: "About",
  services: "Services", 
  contact: "Contact",
  language: "Language",
  
  // Common buttons
  learnMore: "Learn More",
  getQuote: "Get Quote",
  contactUs: "Contact Us",
  bookNow: "Book Now",
  sendMessage: "Send Message",
  
  // Hero section
  heroTitle: "Professional Legal Translation Services",
  heroSubtitle: "Certified translations for legal documents with precision and confidentiality. Serving Utah and beyond with expert bilingual legal translation services.",
  heroButton: "Get Your Quote Today",
  
  // Services
  servicesTitle: "Our Translation Services",
  servicesSubtitle: "Comprehensive legal translation solutions for all your document needs",
  
  service1Title: "Legal Document Translation",
  service1Desc: "Biographical Documents, Legal Records, Police Reports, Medical Records, Statements and Declarations, and Academic Records.",
  
  service2Title: "Certified Translation",
  service2Desc: "Official certified translations for immigration, academic, and legal purposes accepted by courts and government agencies.",
  
  service3Title: "Interpreter Services",
  service3Desc: "Professional interpretation services for depositions, interviews, and legal proceedings.",
  
  service4Title: "Immigration Documents",
  service4Desc: "Specialized translation of birth certificates, marriage certificates, diplomas, and other immigration-related evidence.",
  
  // Service features
  service1Feature1: "Biographical Documents",
  service1Feature2: "Legal Records",
  service1Feature3: "Police Reports",
  service1Feature4: "Medical Records",
  service1Feature5: "Statements and Declarations",
  service1Feature6: "Academic Records",

  service2Feature1: "USCIS Accepted",
  service2Feature2: "Immigration Court (EOIR)",
  service2Feature3: "Academic Transcripts",
  service2Feature4: "Medical Records",
  service2Feature5: "Official Documents",

  service3Feature1: "Depositions",
  service3Feature2: "USCIS Interviews",
  service3Feature3: "Medical Appointments",
  service3Feature4: "Arbitration Proceedings",
  service3Feature5: "Client Interviews",
  
  service4Feature1: "Birth Certificates",
  service4Feature2: "Marriage Certificates",
  service4Feature3: "Academic Records",
  service4Feature4: "Medical Reports",
  service4Feature5: "Witness Statements",
  
  // About section
  aboutTitle: "About Vargas Legal Translation",
  aboutText: "With years of experience in legal translation, Javier Vargas Carrillo provides professional, accurate, and confidential translation services. Our expertise ensures your legal documents maintain their legal validity and precision across languages.",
  
  // Professional Excellence section
  professionalExcellenceTitle: "Professional Excellence",
  professionalExcellenceText1: "Javier Vargas Carrillo brings extensive experience in legal translation, combining deep knowledge of both English and Spanish legal systems with meticulous attention to detail.",
  professionalExcellenceText2: "Javier specializes in translating complex legal and immigration-related documents, including court, medical, educational, and official records, delivering reliable translations that preserve the integrity and meaning of the original text.",
  
  // Testimonials
  testimonialsTitle: "What Our Clients Say",
  
  testimonial1: "Excellent service and attention to detail. Javier translated our legal contracts perfectly and delivered on time.",
  testimonial1Author: "Maria Rodriguez, Immigration Attorney",
  
  testimonial2: "Professional, reliable, and accurate translations. Highly recommended for any legal translation needs.",
  testimonial2Author: "David Thompson, Corporate Lawyer",
  
  testimonial3: "Outstanding quality and fast turnaround. Vargas Legal Translation is our go-to for all document translations.",
  testimonial3Author: "Ana Martinez, Legal Firm",
  
  // CTA section
  ctaTitle: "Ready to Get Started?",
  ctaSubtitle: "Contact us today for professional legal translation services you can trust.",
  ctaButton: "Contact Us Now",
  
  // Contact form
  contactTitle: "Get in Touch",
  contactSubtitle: "Ready to discuss your legal translation needs? Contact us today for a free consultation.",
  getInTouch: "Get in Touch",
  
  // Form labels and placeholders
  firstName: "First Name",
  lastName: "Last Name",
  firstNamePlaceholder: "Enter your first name",
  lastNamePlaceholder: "Enter your last name",
  emailPlaceholder: "Enter your email address",
  phonePlaceholder: "Enter your phone number",
  messagePlaceholder: "Tell us about your translation needs...",
  serviceNeeded: "Service Needed",
  selectService: "Select a service",
  legalTranslation: "Legal Translation",
  immigrationDocuments: "Immigration Documents",
  courtDocuments: "Court Documents",
  medicalRecords: "Medical Records",
  educationalDocuments: "Educational Documents",
  other: "Other",
  characterLimit: "Maximum 500 characters",
  sending: "Sending...",
  messageSuccess: "Thank you! Your message has been sent successfully. We'll get back to you soon.",
  messageError: "Sorry, there was an error sending your message. Please try again or contact us directly.",
  
  // Contact info
  contactInfo: "Contact Information",
  address: "470 W 200 N\\nSalt Lake City, UT 84103",
  email: "javier@vtraduccion.com",
  phone: "(385) 212-4967",
  instagram: "@vargas.legal.translation",
  
  // Contact info labels
  addressLabel: "Address",
  emailContactLabel: "Email",
  phoneContactLabel: "Phone",
  instagramLabel: "Instagram",
  
  // Business hours
  businessHours: "Business Hours",
  mondayFriday: "Monday - Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  businessTime: "9:00 AM - 5:00 PM",
  byAppointment: "By Appointment",
  closed: "Closed",
  
  // Footer
  footerText: "Professional legal translation services in Utah. Certified translations for legal documents, immigration papers, and court proceedings.",
  allRightsReserved: "All rights reserved.",
  
  // About page
  aboutPageTitle: "About Javier Vargas Carrillo",
  aboutPageContent: "Javier Vargas Carrillo is a professional translator specializing in legal document translation with extensive experience in both English and Spanish legal terminology. Based in Utah, Javier provides certified translation services for law firms, individuals, and businesses requiring accurate and legally compliant document translations.",
  
  mission: "Our Mission",
  missionText: "To partner with legal professionals by providing accurate, fast, and reliable translations that save you time, strengthen client representation, and help you win cases.",
  
  values: "Our Values",
  accuracy: "Accuracy",
  accuracyText: "Every translation is meticulously reviewed for legal accuracy and linguistic precision.",
  confidentiality: "Confidentiality", 
  confidentialityText: "We maintain strict confidentiality protocols to protect sensitive legal information.",
  reliability: "Reliability",
  reliabilityText: "Timely delivery and consistent quality you can depend on for all your legal translation needs.",
  
  // Process steps
  processTitle: "Our Translation Process",
  processSubtitle: "A systematic approach ensuring accuracy and quality in every translation",
  
  process1Title: "Document Review",
  process1Desc: "Initial assessment of your documents and translation requirements",
  
  process2Title: "Quote & Timeline",
  process2Desc: "Detailed quote with transparent pricing and delivery timeline",
  
  process3Title: "Translation",
  process3Desc: "Professional translation with attention to legal terminology",
  
  process4Title: "Quality Review",
  process4Desc: "Thorough review and certification before final delivery"
};

export default common;
